'use client'

import { cn } from '@/shared/lib'
import { Button, Dialog } from '@/shared/ui'

type Props = {
  isOpen: boolean
  onOpenChange: (open?: boolean) => void
  title?: string
  content: string
  onConfirm?: (() => void) | null
  confirmText?: string
  cancelText?: string
  onCancel?: (() => void) | null
  preventOutsideClick?: boolean
}

export const ConfirmDialog = ({
  isOpen,
  onOpenChange,
  title,
  content,
  onConfirm,
  onCancel,
  confirmText = '확인',
  cancelText = '닫기',
  preventOutsideClick = false,
}: Props) => {
  const handleOpenChange = (open?: boolean) => {
    if (!open && preventOutsideClick) {
      return
    }

    onOpenChange(open)
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()

      return
    }

    onOpenChange(false)
  }

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()

      return
    }

    onOpenChange(false)
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content
        className="w-[335px] gap-5 p-5 text-center"
        closeButton={false}
      >
        <Dialog.Header className="min-h-15 justify-center gap-5">
          <Dialog.Title
            className={cn('typo-headline3 whitespace-break-spaces', {
              hidden: !title,
            })}
          >
            {title}
          </Dialog.Title>
          <Dialog.Description className="typo-label1 whitespace-break-spaces">
            {content}
          </Dialog.Description>
        </Dialog.Header>
        <Dialog.Footer className={cn('flex-row', { 'px-1': !title })}>
          <Button
            size="large"
            color="secondary"
            fullWidth
            onClick={handleCancel}
          >
            {cancelText}
          </Button>
          <Button size="large" fullWidth onClick={handleConfirm}>
            {confirmText}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
